import script from "./EditView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditView.vue?vue&type=script&setup=true&lang=ts"

import "./EditView.vue?vue&type=style&index=0&id=2ff9bcaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff9bcaa"]])

export default __exports__